<div *ngIf="!cookieConsentService.hasConsented()" class="cookie-consent">
    <div>Usamos cookies en nuestra página web para ofrecerte la mejor experiencia online. Déjanos saber si aceptas todas
        estas cookies. <a style="color: white; text-decoration: underline;" href="https://www.directoapp.pe/politicadecookies" target="_blank">Conoce nuestra Política de cookies</a></div>
    <div class="button-group">
        <button (click)="denyCookies()">Denegar</button>
        <button (click)="acceptCookies()">Aceptar</button>
        <span style="margin-left: 20px; cursor: pointer;" (click)="denyCookies()">X</span>
    </div>
</div>